import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { ProductCard } from "./ProductCard";

export const ProductCarousel = ({ products, loading, testid = "product-carousel" }) => {
  const [api, setApi] = useState(null);
  const [state, setState] = useState({ prev: false, next: true, progress: 0 });

  useEffect(() => {
    if (!api) return;
    const update = () => setState({ prev: api.canScrollPrev(), next: api.canScrollNext(), progress: Math.max(0, Math.min(1, api.scrollProgress())) });
    update();
    api.on("select", update).on("scroll", update).on("reInit", update);
  }, [api]);

  if (loading) return <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">{[0, 1, 2, 3].map((i) => <div key={i} className="aspect-[4/5] bg-white/5 animate-pulse" />)}</div>;

  const btn = "h-12 w-12 rounded-full border border-[#c9a55c]/50 text-[#e3cb94] flex items-center justify-center transition-[background-color,opacity,transform] duration-300 hover:bg-[#c9a55c] hover:text-[#0b0a08] hover:scale-110 disabled:opacity-25 disabled:pointer-events-none";
  return (
    <div data-testid={testid} data-lenis-prevent-horizontal>
      <Carousel setApi={setApi} opts={{ align: "start", dragFree: true }}>
        <CarouselContent className="-ml-4 lg:-ml-8">
          {products.map((p, i) => (
            <CarouselItem key={p.id} className="pl-4 lg:pl-8 basis-[72%] sm:basis-[42%] lg:basis-[28%] xl:basis-1/4">
              <ProductCard product={p} index={i} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      <div className="flex items-center gap-6 mt-10">
        <div className="flex-1 h-px bg-white/10 overflow-hidden">
          <motion.div className="h-full bg-gold origin-left" animate={{ scaleX: 0.15 + state.progress * 0.85 }} transition={{ type: "spring", stiffness: 120, damping: 20 }} />
        </div>
        <button data-testid={`${testid}-prev`} aria-label="Previous" disabled={!state.prev} onClick={() => api?.scrollPrev()} className={btn}><ArrowLeft size={18} /></button>
        <button data-testid={`${testid}-next`} aria-label="Next" disabled={!state.next} onClick={() => api?.scrollNext()} className={btn}><ArrowRight size={18} /></button>
      </div>
    </div>
  );
};
